import React from 'react'
import { DataProxy } from 'apollo-cache'
import { FetchResult } from 'apollo-link'

import { Dropdown } from '@sketch/components'
import {
  usePinShareMutation,
  useUnpinShareMutation,
  PinShareMutation,
  UnpinShareMutation,
} from '@sketch/gql-types'

export interface VersionsForDropdown {
  current: { shortId: string }
  latest: { shortId: string }
}

export interface PinDocumentProps {
  shareIdentifier: string
  pinned: boolean
  update?: (
    cache: DataProxy,
    data: FetchResult<PinShareMutation> | FetchResult<UnpinShareMutation>
  ) => void
}

export const PinDocument = ({
  update,
  shareIdentifier,
  pinned,
}: PinDocumentProps) => {
  const [pinShare] = usePinShareMutation({
    variables: {
      shareIdentifier,
    },
    onError: 'show-toast',
    update,
  })

  const [unpinShare] = useUnpinShareMutation({
    variables: {
      shareIdentifier,
    },
    onError: 'show-toast',
    update,
  })

  return (
    <Dropdown.Item
      onClick={() => {
        if (pinned) {
          return unpinShare({ variables: { shareIdentifier } })
        }
        return pinShare({ variables: { shareIdentifier } })
      }}
    >
      {pinned ? 'Unpin Document' : 'Pin Document'}
    </Dropdown.Item>
  )
}
